module.exports = __webpack_public_path__ + "static/media/do1.db19c348.png";